import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const COLOMBIAN_TIMEZONE = 'America/Bogota'

/**
 * Normaliza una fecha de cualquier formato (string, Date, Firestore Timestamp, Dayjs)
 * a una instancia de Dayjs en zona horaria colombiana
 * Retorna null si la fecha no es válida
 */
export const parseDateToDayjs = (dateValue: any): Dayjs | null => {
  if (!dateValue) return null

  try {
    // Si ya es Dayjs y es válido, convertir a zona colombiana
    if (dayjs.isDayjs(dateValue)) {
      return dateValue.isValid() ? dateValue.tz(COLOMBIAN_TIMEZONE) : null
    }

    // Si es string
    if (typeof dateValue === 'string') {
      const parsed = dayjs(dateValue).tz(COLOMBIAN_TIMEZONE)
      return parsed.isValid() ? parsed : null
    }

    // Si es Date
    if (dateValue instanceof Date) {
      const parsed = dayjs(dateValue).tz(COLOMBIAN_TIMEZONE)
      return parsed.isValid() ? parsed : null
    }

    // Si es Firestore Timestamp (tiene método toDate)
    if (dateValue?.toDate && typeof dateValue.toDate === 'function') {
      try {
        const parsed = dayjs(dateValue.toDate()).tz(COLOMBIAN_TIMEZONE)
        return parsed.isValid() ? parsed : null
      } catch (err) {
        return null
      }
    }

    // Si es un objeto de timestamp (con _seconds y _nanoseconds)
    if (dateValue?._seconds) {
      const parsed = dayjs(dateValue._seconds * 1000).tz(COLOMBIAN_TIMEZONE)
      return parsed.isValid() ? parsed : null
    }

    // Intenta parsear como fallback
    const parsed = dayjs(dateValue).tz(COLOMBIAN_TIMEZONE)
    return parsed.isValid() ? parsed : null
  } catch (err) {
    console.error('Error parsing date:', err)
    return null
  }
}
